import { COLORS } from 'src/constants/Color';

// eslint-disable-next-line @typescript-eslint/naming-convention
export enum SUBSCRIPTION_STATUS {
  success = 'success',
  failed = 'failed',
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SUBSCRIPTION_STATUS_COLOR = {
  [SUBSCRIPTION_STATUS.success]: COLORS.action,
  [SUBSCRIPTION_STATUS.failed]: COLORS.red,
};
